import { postAxios, getAxios } from '@/lib/http';

export const categoryApi = {
  // 查询类目层级树 by listen
  getCategoryTree () {
    return getAxios('/app/category/tree');
  }
};
